
import { Component, Vue } from 'nuxt-property-decorator'
import type { MetaInfo } from 'vue-meta'
import { Context } from '@nuxt/types'
import StudyCaseBody from '~/components/study-case/StudyCaseBody.vue'
import { WithHead } from '~/core/vue.types'
import { FeatureFlags } from '~/core/config/feature-flags'
import { useSEOMetaComposer } from '~/composables/seo.composable'

@Component({
  nuxtI18n: {
    locales: ['de'],
    paths: {
      de: '/handy-und-internet-abos-fuer-geschaeftskunden/fallstudie/kernstuder',
    },
  },
  components: {
    StudyCaseBody,
  },
  middleware: ({ error, $featureFlags }: Context) => {
    if (!$featureFlags.isEnabled(FeatureFlags.B2B_PAGE)) {
      error({ statusCode: 404 })
    }
  },
})
export default class KernStuderCase extends Vue implements WithHead {
  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.title,
        description: 'alao Fallstudie für Geschäftskunden - So senkte alao die Kosten für dir Kern Studer AG um 50 % bei ihren Handy-Abos und vereinfachte die Buchführung.',
        route: { name: 'b2b-fallstudie-kern-studer' },
      },
    )
  }

  get title (): string {
    return '50% Kostensenkung bei Handy-Abos für die Kern Studer AG dank alao'
  }
}
